import {
  Settings,
  AdminPanelSettings,
  Groups as GroupsIcon,
  Dashboard as DashboardIcon,
  Folder as FolderIcon,
  Book as BookIcon,
  ManageAccounts as ManageAccountsIcon,
  Science as ScienceIcon,
  Insights as InsightsIcon,
  PlaylistAddCheck as PlaylistAddCheckIcon,
} from '@mui/icons-material';
import { PERMISSIONS } from '../../config/permissions';
import { USER_ROLES } from '../../config/constants';

/**
 * Hoofdnavigatie (balk op desktop, lade op mobiel), in vaste volgorde.
 * Een item zonder `permission` is voor iedereen zichtbaar.
 */
export const NAV_ITEMS = [
  { path: '/', label: 'Dashboard', icon: DashboardIcon },
  { path: '/projects', label: 'Projecten', icon: FolderIcon, permission: PERMISSIONS.VIEW_PROJECT },
  { path: '/library', label: 'Bibliotheek', icon: BookIcon, permission: PERMISSIONS.VIEW_LIBRARY },
  {
    path: '/project-management',
    label: 'Projectbeheer',
    icon: ManageAccountsIcon,
    permission: PERMISSIONS.VIEW_PROJECT_MANAGEMENT,
  },
  { path: '/metrics', label: 'Metrics', icon: InsightsIcon, permission: PERMISSIONS.VIEW_METRICS },
];

/** Items in het gebruikersmenu (boven "Uitloggen"), in vaste volgorde. */
export const USER_MENU_ITEMS = [
  { path: '/settings', label: 'Instellingen', icon: Settings },
  { path: '/stof-suggesties', label: 'Stofsuggesties', icon: ScienceIcon },
  {
    path: '/stoffenpakketten',
    label: 'Stoffenpakketten',
    icon: PlaylistAddCheckIcon,
    permission: PERMISSIONS.MANAGE_STOFFENPAKKETTEN,
  },
  {
    path: '/employee-management',
    label: 'Werknemer Beheer',
    icon: GroupsIcon,
    permission: PERMISSIONS.MANAGE_EMPLOYEES,
  },
  {
    path: '/admin',
    label: 'Admin Panel',
    icon: AdminPanelSettings,
    permission: PERMISSIONS.MANAGE_USERS,
  },
];

/** Filtert items op de rechten van de gebruiker. */
export const visibleItems = (items, hasPermission) =>
  items.filter((item) => !item.permission || hasPermission(item.permission));

// Let op: USER_ROLES.EMPLOYEE bestaat niet in constants.js, dus deze sleutel is de
// string 'undefined'. Dat is bewust overgenomen van de oude switch: een rol die nog
// niet bekend is (undefined) toont 'Medewerker'.
const ROLE_DISPLAY = {
  [USER_ROLES.ADMIN]: { label: 'Beheerder', color: 'error' },
  [USER_ROLES.PROJECT_MANAGER]: { label: 'Projectmanager', color: 'warning' },
  [USER_ROLES.EMPLOYEE]: { label: 'Medewerker', color: 'info' },
};

export const getRoleDisplayName = (userRole) => ROLE_DISPLAY[userRole]?.label ?? 'Gebruiker';

export const getRoleColor = (userRole) => ROLE_DISPLAY[userRole]?.color ?? 'default';

/** Is `path` de actieve route? `/` telt alleen bij een exacte match. */
export const isActivePath = (pathname, path) =>
  path === '/' ? pathname === '/' : pathname.startsWith(path);
